import Alpine from "alpinejs"
import Components from "components"
import Plugins from "plugins"

// Initialise Alpine
window.Alpine = Alpine
Alpine.start()

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"



jQuery(function ($) {
    console.log('test-0')
    Components.init();

    Plugins.init();
    console.log('test-1')
    fadeSlideInElement();
    $(window).on('scroll', function () {
        fadeSlideInElement();
    })
});

function fadeSlideInElement() {

    console.log('test')
    var elementsToFadeIn = jQuery('.not-appear');
    if (!elementsToFadeIn.length) return;
    var elementsToProcess = [];
    elementsToFadeIn.each(function () {
        var element = jQuery(this);
        if (!element.hasClass('fade-in') && element.isInViewport()) elementsToProcess.push(element);
    });
    jQuery.each(elementsToProcess, function (index, element) {
        setTimeout(function () {
            element.addClass('fade-in');
        }, index * 200);
    });
}
jQuery.fn.isInViewport = function () {
    var elementTop = jQuery(this).offset().top;
    var elementBottom = elementTop + jQuery(this).outerHeight();
    var viewportTop = jQuery(window).scrollTop();
    var viewportBottom = viewportTop + jQuery(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};
